import React from 'react'
import { getSHiftDisplayName } from '../../../utility/RolesUtility'
interface infoData {
    submittedData:any
  }
const ServicesOffered:React.FC<infoData>=({submittedData})=> {
  return (
    <>
    {submittedData?.serviceOfferedDtos && submittedData?.serviceOfferedDtos?.length > 0  &&
    <div className='bg-white my-8 p-8 px-8'>
      
        <div className=" pb-4">
          <p className="font-bold text-2xl text-primary-color border-b  border-b-gray-200 pb-5">
            Service(s) Offered
          </p>
          <div className="grid grid-cols-2 gap-8 mt-5">
          {submittedData?.serviceOfferedDtos?.map((service:any, index:number) => (
  <div
    key={index}
    className="font-sans border border-gray-200 rounded-lg py-4 pl-4 "
  >
    <p className="font-bold text-[20px] text-gray-900">{getSHiftDisplayName(service?.type)}</p>
    <p className="font-normal text-sm text-gray-600 pt-2">Approximate Cost</p>
    <p className="font-semibold text-base text-gray-600 pt-2">
      {service.cost ? `${service?.mtCurrencyDto?.mtCurrencyCode} ${service.cost.toLocaleString()}` : "-"}
    </p>
  </div>
))}

           
          </div>
        </div>
        
    </div>}</>
  )
}

export default ServicesOffered
